import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CheckCircle2, XCircle, Loader2, Lock } from "lucide-react";

const TZ = "America/Santiago";
const fmt = (iso) => new Date(iso).toLocaleString("es-CL", { timeZone: TZ, day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false });

export const ATT_LABEL = { confirmed: "Asistiré", declined: "No asistiré", sin_respuesta: "Sin confirmar" };

export function AttendanceToggle({ r, s, onChanged, compact }) {
  const [busy, setBusy] = useState(null);
  const open = new Date(s.starts_at) > new Date();
  const onTime = new Date(s.notice_deadline) > new Date();
  const set = async (status) => {
    setBusy(status);
    try {
      const { data } = await api.post(`/attendance/${r.id}/${s.id}`, { status });
      toast.success(status === "declined"
        ? (data.late ? "Cancelaste fuera de plazo: el cupo queda libre, pero no sumas crédito." : `Avisaste que no asistirás. Sumaste ${data.credits_created} crédito(s).`)
        : "¡Confirmaste tu asistencia!");
      onChanged?.();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(null); }
  };
  const btn = (status, Icon, label, tone) => {
    const active = s.attendance === status;
    return (
      <Button type="button" size="sm" variant={active ? "default" : "outline"} disabled={!open || !!busy}
        className={`flex-1 ${active ? tone : ""}`} onClick={() => set(status)} data-testid={`att-${status}-${s.id}`}>
        {busy === status ? <Loader2 className="w-4 h-4 animate-spin" /> : <Icon className="w-4 h-4 mr-1" />}{label}
      </Button>
    );
  };
  return (
    <div className={compact ? "space-y-1.5" : "space-y-2"} data-testid={`attendance-${s.id}`}>
      <div className="flex gap-2">
        {btn("confirmed", CheckCircle2, "Asistiré", "bg-emerald-600 hover:bg-emerald-600")}
        {btn("declined", XCircle, "No asistiré", "bg-rose-600 hover:bg-rose-600")}
      </div>
      <p className="text-[11px] text-muted-foreground flex items-center gap-1" data-testid={`att-deadline-${s.id}`}>
        {!open ? <><Lock className="w-3 h-3" />La sesión ya comenzó · {ATT_LABEL[s.attendance]}</>
          : onTime ? <>Avisa antes del {fmt(s.notice_deadline)} hrs ({r.attendance_notice_hours} h antes) para ganar un crédito.</>
          : s.attendance === "declined" ? <>Cancelaste fuera de plazo: no sumaste crédito.</>
          : <>Plazo de {r.attendance_notice_hours} h vencido: puedes cancelar, pero no ganarás crédito.</>}
      </p>
    </div>
  );
}
